import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "left-col col" }
const _hoisted_2 = { class: "filters col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header name" }, "Filters", -1)
const _hoisted_4 = {
  key: 0,
  class: "icon minimize",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  class: "path fill",
  x: "5",
  y: "11",
  width: "14",
  height: "2"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "icon add plus more",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  class: "path fill",
  d: "M11 5V11H5V13H11V19H13V13H19V11H13V5H11Z"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Clear all", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon close times",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "path fill",
    d: "M19 6.4L17.6 5L12 10.6L6.4 5L5 6.4L10.6 12L5 17.6L6.4 19L12 13.4L17.6 19L19 17.6L13.4 12L19 6.4Z"
  })
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "scroll-container scroll-y" }
const _hoisted_14 = {
  key: 0,
  class: "col"
}
const _hoisted_15 = { class: "section col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "header name" }, "Location", -1)
const _hoisted_17 = {
  key: 0,
  class: "icon minimize",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("rect", {
  class: "path fill",
  x: "5",
  y: "11",
  width: "14",
  height: "2"
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "icon add plus more",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  class: "path fill",
  d: "M11 5V11H5V13H11V19H13V13H19V11H13V5H11Z"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["row name", ('showFilters'?'active':'')]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onSectionClick("filters")))
      }, [
        _hoisted_3,
        ($setup.showFilters)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
      ])
    ]),
    _createElementVNode("button", {
      class: "clear-filters",
      onClick: $setup.handleClearFilters
    }, _hoisted_12),
    _createElementVNode("div", _hoisted_13, [
      ($setup.showFilters)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: _normalizeClass(["row name", ('showLocation'? 'active': '')]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showLocation=!$setup.showLocation))
              }, [
                _hoisted_16,
                ($setup.showLocation)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
              ]),
              ($setup.showLocation)
                ? (_openBlock(), _createBlock($setup["FilterSection"], {
                    key: 0,
                    class: "sub section col",
                    "filter-name": "Country",
                    options: $setup.organizations.HQCountryOptions,
                    "onUpdate:selectedOptions": _cache[2] || (_cache[2] = ($event: any) => ($setup.handleFilterSelection('Country', $event)))
                  }, null, 8, ["options"]))
                : _createCommentVNode("", true),
              ($setup.showLocation)
                ? (_openBlock(), _createBlock($setup["FilterSection"], {
                    key: 1,
                    class: "sub section col",
                    "filter-name": "State/Province",
                    options: $setup.organizations.HQStateOptions,
                    "onUpdate:selectedOptions": _cache[3] || (_cache[3] = ($event: any) => ($setup.handleFilterSelection('State/Province', $event)))
                  }, null, 8, ["options"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode($setup["FilterSection"], {
              class: "section col",
              "filter-name": "Profit Type",
              options: ['Non-Profit','For Profit'],
              "onUpdate:selectedOptions": _cache[4] || (_cache[4] = ($event: any) => ($setup.handleFilterSelection('Profit Type', $event)))
            }),
            _createVNode($setup["FilterSection"], {
              class: "section col",
              "filter-name": "Focus",
              options: ['Primarily ALS Focused', 'Related Disease Focus', 'Non ALS Focused'],
              "onUpdate:selectedOptions": _cache[5] || (_cache[5] = ($event: any) => ($setup.handleFilterSelection('Focus', $event)))
            }),
            _createVNode($setup["FilterSection"], {
              class: "section col",
              "filter-name": "Services or Resources",
              options: ['Raise Awareness', 'Online Resources', 'Conducts Research', 'Funds ALS Research', 'Consortia', 'Online Information'],
              "onUpdate:selectedOptions": _cache[6] || (_cache[6] = ($event: any) => ($setup.handleFilterSelection('ServicesOrResources', $event)))
            }),
            _createVNode($setup["FilterSection"], {
              class: "section col",
              "filter-name": "Support Groups",
              options: ['Online', 'In Person'],
              "onUpdate:selectedOptions": _cache[8] || (_cache[8] = ($event: any) => ($setup.handleFilterSelection('Support Groups', $event)))
            }, {
              default: _withCtx(() => [
                _createVNode($setup["FilterSection"], {
                  class: "section col",
                  "filter-name": "Funds or Grants",
                  options: ['Home Care', 'Adaptive Tech', 'Research', 'Support Groups'],
                  "onUpdate:selectedOptions": _cache[7] || (_cache[7] = ($event: any) => ($setup.handleFilterSelection('FundsOrGrants', $event)))
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}